import React, { useEffect, useState } from "react";
import { notification } from "antd";
import { useTranslation } from "react-i18next";
import Representation from "./Representation";
import { fetchMcpProStatus } from "util/mcpApi";
import { MCP_SERVER_URL, copyTextToClipboard } from "util/mcpSetup";

const McpView = ({ onBack }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [urlCopied, setUrlCopied] = useState(false);

  useEffect(() => {
    let active = true;
    fetchMcpProStatus().then((res) => {
      if (!active) return;
      setStatus(res && !res.error && !res.cancel ? res : null);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  const handleCopyUrl = async () => {
    const ok = await copyTextToClipboard(MCP_SERVER_URL);
    if (ok) {
      setUrlCopied(true);
      window.setTimeout(() => setUrlCopied(false), 2000);
      notification.success({ message: t("mcp_connector.copied") });
    }
  };

  return (
    <Representation
      t={t}
      onBack={onBack}
      loading={loading}
      status={status}
      urlCopied={urlCopied}
      onCopyUrl={handleCopyUrl}
    />
  );
};

export default McpView;
